import { useMemo } from 'react';

const MAX_MIDDLE_PAGES = 10;

interface UsePaginationProps {
  currentPage: number;
  totalPages: number;
}

export default function usePagination(props: Readonly<UsePaginationProps>) {
  const { currentPage, totalPages } = props;

  const firstPage = 1;
  const lastPage = totalPages;
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === totalPages;
  const previousPage = isFirstPage ? 1 : currentPage - 1;
  const nextPage = isLastPage ? totalPages : currentPage + 1;

  const pages = useMemo((): (number | string)[] => {
    const pagesArray: (number | string)[] = [1];

    const start = Math.max(
      2,
      Math.min(
        currentPage - Math.floor(MAX_MIDDLE_PAGES / 2),
        totalPages - MAX_MIDDLE_PAGES
      )
    );

    const end = Math.min(totalPages - 1, start + MAX_MIDDLE_PAGES - 1);

    if (start > 2) {
      pagesArray.push('...');
    }

    for (let i = start; i <= end; i++) {
      pagesArray.push(i);
    }

    if (end < totalPages - 1) {
      pagesArray.push('...');
    }

    if (totalPages > 1) {
      pagesArray.push(totalPages);
    }

    return pagesArray;
  }, [currentPage, totalPages]);

  return {
    firstPage,
    lastPage,
    isFirstPage,
    isLastPage,
    previousPage,
    nextPage,
    pages,
  };
}
